import actions from "./actions";

const initialState = {
  createMdnSwapLoading: false,
  createMdnSwapMessage: null,
  createMdnSwapError: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.CREATE_MDN_SWAP_REQUEST:
      return {
        ...state,
        createMdnSwapLoading: true,
        createMdnSwapMessage: null,
        createMdnSwapError: null,
      };

    case actions.CREATE_MDN_SWAP_REQUEST_SUCCESSFUL:
      return {
        ...state,
        createMdnSwapLoading: false,
        createMdnSwapMessage: action.message,
        createMdnSwapError: null,
      };

    case actions.CREATE_MDN_SWAP_REQUEST_FAILED:
      return {
        ...state,
        createMdnSwapLoading: false,
        createMdnSwapMessage: null,
        createMdnSwapError: action.error,
      };

    default:
      return state;
  }
};

export default reducer;
